__turbopack_context__.v({
  "close-container": "Tooltip-module-scss-module__pz9pQa__close-container",
  "container": "Tooltip-module-scss-module__pz9pQa__container",
});
